export function formatApiError(error) {
  try {
    if (!error) return { message: 'An unexpected error occurred', code: null, type: null, raw: error }

    // Check if error or error.message is a JSON string
    let errObj = null
    if (typeof error === 'string' && error.trim().startsWith('{')) {
      try { errObj = JSON.parse(error.trim()) } catch (e) {}
    } else if (typeof error?.message === 'string' && error.message.trim().startsWith('{')) {
      try { errObj = JSON.parse(error.message.trim()) } catch (e) {}
    }

    if (errObj && typeof errObj === 'object') {
      const innerErr = (errObj.error && typeof errObj.error === 'object') ? errObj.error : errObj
      return {
        error_code: innerErr?.error_code ?? innerErr?.code ?? error?.response?.status ?? null,
        code: innerErr?.code ?? error?.response?.status ?? null,
        message: innerErr?.message ?? (typeof innerErr?.error === 'string' ? innerErr?.error : null) ?? innerErr?.detail ?? 'An unexpected error occurred',
        type: innerErr?.type ?? null,
        raw: error
      }
    }

    const apiErr = error?.response?.data?.error || error?.response?.data || null
    if (apiErr && typeof apiErr === 'object') {
      const innerErr = (apiErr.error && typeof apiErr.error === 'object') ? apiErr.error : apiErr
      return {
        code: innerErr?.code ?? error?.response?.status ?? null,
        error_code: innerErr?.error_code ?? innerErr?.code ?? null,
        message: innerErr?.message ?? (typeof innerErr?.error === 'string' ? innerErr?.error : null) ?? innerErr?.detail ?? error?.message ?? 'An unexpected error occurred',
        type: innerErr?.type ?? null,
        raw: error
      }
    }

    if (typeof error?.message === 'string') {
      try {
        const parsed = JSON.parse(error.message)
        if (parsed && typeof parsed === 'object') {
          const innerErr = (parsed.error && typeof parsed.error === 'object') ? parsed.error : parsed
          return {
            error_code: innerErr?.error_code ?? error?.response?.status ?? null,
            code: innerErr?.code ?? error?.response?.status ?? null,
            message: innerErr?.message ?? (typeof innerErr?.error === 'string' ? innerErr?.error : null) ?? innerErr?.detail ?? error.message,
            type: innerErr?.type ?? null,
            raw: error
          }
        }
      } catch (e) {
        // fallthrough
      }
    }

    return {
      error_code: error?.response?.status ?? error?.error_code ?? null,
      code: error?.response?.status ?? error?.code ?? null,
      message: error?.message ?? String(error) ?? 'An unexpected error occurred',
      type: error?.name ?? null,
      raw: error
    }
  } catch (e) {
    return { message: 'An unexpected error occurred', code: null, type: null, raw: error }
  }
}

export default formatApiError
